import { dataTrigger } from "@/analytics";
import { updateMySubscription } from "@/api/subscriptions";
import { useAuth } from "@/store/authStore";

import cls from "../CancelSubscription/styles.module.scss";

export function ResumeSubscription() {
  const me = useAuth((s) => s.me);
  const setMe = useAuth((s) => s.setMe);

  const isResumeAvailable =
    Boolean(me?.subscription?.is_active) && !me?.subscription?.auto_renew;

  const onResume = async () => {
    if (!me?.subscription || !isResumeAvailable) return;

    await updateMySubscription({ auto_renew: true });

    setMe({
      ...me,
      subscription: {
        ...me.subscription,
        auto_renew: true,
      },
    });
  };

  if (!isResumeAvailable) return null;

  return (
    <button
      type="button"
      className={cls.cancelLink}
      onClick={onResume}
      {...dataTrigger("bkn.main.resume_subscription")}
    >
      Возобновить подписку
    </button>
  );
}
